import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openModal, closeModal, toggleModal, getModalByName, getIsSomeModalOpen } from '@/shared/slices/modalSlice';

export type useToggleModalStateProps = {
  name: string;
}

export const useToggleModalState = ({
  name = '',
}: useToggleModalStateProps) => {
  const dispatch = useDispatch();
  const modalState = useSelector(getModalByName(name));

  const handleOpenModal = useCallback((payload?: any) => {
    dispatch(openModal(name, payload));
  }, [dispatch, name]);

  const handleCloseModal = useCallback(() => {
    dispatch(closeModal(name));
  }, [dispatch, name]);

  const handleToggleModal = useCallback((show: boolean, payload?: any) => {
    dispatch(toggleModal(name, show, payload));
  }, [dispatch, name]);

  return useMemo(() => ({
    isShow: modalState.show,
    payload: modalState.payload,
    openModal: handleOpenModal,
    closeModal: handleCloseModal,
    toggleModal: handleToggleModal,
  }), [modalState, handleOpenModal, handleCloseModal, handleToggleModal]);
};

export const useIsSomeModalOpen = () => {
  const isSomeModalOpen = useSelector(getIsSomeModalOpen);
  return isSomeModalOpen;
};
